import { Link } from "react-router-dom";
import { Button } from "@/shared/components/ui/button";

export function NotFoundPage() {
  return (
    <div
      data-testid="not-found-screen"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ge-app p-6 text-center"
    >
      <h1 className="font-sans text-[24px] font-bold text-ge-primary">Page not found</h1>
      <p className="text-[13px] text-ge-secondary">That route doesn&apos;t exist.</p>
      <Button asChild>
        <Link to="/campaigns" data-testid="nav-home">
          Back to campaigns
        </Link>
      </Button>
    </div>
  );
}
